module.exports = __webpack_public_path__ + "img/mapa.c265b78e.png";